/* eslint-disable */
import dicts from './example'

export const branchEventCols = [
  {
    title: '活动名称',
    key: 'eventName',
    tooltip: true,
    width: 200,
  },
  {
    title: '活动类型',
    slot: 'eventType',
    tooltip: true,
    width: 150,
  },
  {
    title: '活动时间',
    key: 'eventTime',
    tooltip: true,
    width: 150,
  },
  {
    title: '活动地点',
    slot: 'placeType',
    width: 160,
  },
  {
    title: '党员之家',
    key: 'homeName',
    width: 240,
    tooltip: true,
  },
  {
    title: '是否为特色活动',
    slot: 'isSpecial',
    width: 180,
  },
  {
    title: '是否推荐至数字驾驶舱',
    slot: 'isPush',
    width: 200,
  },
  {
    title: '活动主题',
    key: 'subject',
    width: 240,
    tooltip: true,
  },
  {
    title: '活动主要内容',
    slot: 'content',
    width: 240,
  },
  {
    title: '特邀人士',
    key: 'invitation',
    width: 160,
    tooltip: true,
  },
  {
    title: '应到人数',
    key: 'shouldCount',
    width: 160,
  },
  {
    title: '实到人数',
    key: 'actualCount',
    width: 160,
  },
  {
    title: '照片附件',
    slot: 'fileUrl',
    width: 200,
  },
  {
    title: '记录人',
    key: 'recordUser',
    width: 160,
    tooltip: true,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchEventForm = {
  attrs: {
    labelWidth: '180px',
    'label-position': 'left',
    rules: {
      eventType: [
        {
          required: true,
          message: '请选择活动类型',
          trigger: 'change',
        },
      ],
      eventTime: [
        {
          required: true,
          message: '请选择活动时间',
          trigger: 'change',
        },
      ],
      placeType: [
        {
          required: true,
          message: '请选择活动地点',
          trigger: 'change',
        },
      ],
      homeUid: [
        {
          required: true,
          message: '请选择党员之家',
          trigger: 'change',
        },
      ],
      isSpecial: [
        {
          required: true,
          message: '请选择是否为特色活动',
          trigger: 'change',
        },
      ],
      isPush: [
        {
          required: true,
          message: '请选择是否推荐',
          trigger: 'change',
        },
      ],
      subject: [
        {
          required: true,
          message: '请输入活动主题',
          trigger: 'blur',
        },
      ],
      content: [
        {
          required: true,
          message: '请输入活动主要内容',
          trigger: 'blur',
        },
      ],
      invitation: [
        { required: true, message: '请输入特邀人士', trigger: 'blur' },
      ],
      shouldCount: [
        { required: true, message: '请输入应到人数', trigger: 'blur' },
      ],
      actualCount: [
        { required: true, message: '请输入实到人数', trigger: 'blur' },
      ],
      // fileUrl: [
      //   {
      //     required: true,
      //     message: '请选择照片附件',
      //     trigger: 'change',
      //   },
      // ],
      recordUser: [
        { required: true, message: '请输入记录人', trigger: 'blur' },
      ],
    },
  },
  items: [
    {
      label: '活动名称',
      prop: 'eventName',
      maxlength: 50,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '活动类型',
      prop: 'eventType',
      options: dicts.activityType(),
    },
    {
      type: 'datepicker',
      label: '活动时间',
      prop: 'eventTime',
      clearable: true,
      format: 'yyyy-MM-dd',
      dateType: 'date',
      attrs: {
        valueFormat: 'yyyy-MM-dd'
      }
    },
    {
      type: 'select',
      label: '活动地点',
      prop: 'placeType',
      options: [
        { label: '党员之家', value: 1 },
        { label: '其他地点', value: 2 },
        { label: '线上', value: 3 },
      ],
    },
    {
      type: 'select-remote',
      label: '党员之家',
      prop: 'homeUid',
      filterable: true,
      remote: true,
      paramsKey: 'keyword',
      params: {
        // projectUid: cache.get('PROJECTUID') || '',
        // branchUid: cache.get('BRANCHID') || '',
        // from: 1,
        // size: 10,
      },
      remoteAction: 'getHomeListApi',
      labelName: 'name',
      valueName: 'uid',
      hidden: true,
    },
    {
      type: 'select',
      label: '是否为特色活动',
      prop: 'isSpecial',
      options: [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
      ],
    },
    {
      type: 'select',
      label: '是否推荐至数字驾驶舱',
      prop: 'isPush',
      options: [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
      ],
    },
    {
      label: '活动主题',
      prop: 'subject',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '特邀人士',
      prop: 'invitation',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '应到人数',
      prop: 'shouldCount',
      type: 'input-number',
      attrs: {
        min: 0,
        max: 999,
        precision: 0
      },
    },
    {
      label: '实到人数',
      prop: 'actualCount',
      type: 'input-number',
      attrs: {
        min: 0,
        max: 999,
        precision: 0
      },
    },
    {
      label: '记录人',
      prop: 'recordUser',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'textarea',
      label: '活动主要内容',
      prop: 'content',
      className: 'branch-event-content-input',
      maxlength: 500,
      showWordLimit: true,
      rows: 6,
    },
    {
      type: 'file-upload-imgVideo-mutiple',
      label: '照片附件',
      prop: 'fileUrl',
      noLimitSize: true
    }
  ],
}
